var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpOuterwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10c4-1 7-6 7-6h10s3 5.2 7 6l6 21h-8v13H14V31H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 4l5 14l5-14m-5 14v26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpOuterwear);
export default __webpack_public_path__ + "static/media/icon-ip-outerwear.2ec128e1848be54c2dfe9c8b61ec4815.svg";
export { ForwardRef as ReactComponent };